export default {
    common: {
        email: 'Email',
        LoginBtn: 'Accesso',
        SignUpBtn: 'Iscriviti',
        SubmitBtn: 'Confermare',
        ExitBtn: 'Lasciare',
        LogoutBtn: 'Disconnessione'
    },
    login: {},
    login2FA: {
        pleaseCheckEmail: 'Controlla la tua e-mail per il codice di verifica.',
        VerificationCode: 'Codice di verifica'
    },
    header: {
        OrderHistory: 'Storico ordini',
        MYACCOUNT: 'IL MIO ACCOUNT',
        WelcomeBack: 'Benvenuto'
    },
    detail: {
        TotalOrders: 'Totale ordini',
        TotalProducts: 'Totale prodotti',
        WonderlandPoints: 'Punti Wonderland',
        APMCredits: 'APM Crediti',
        ExpireOn: 'Scade il',
        NoAPMCredits: 'Nessun crediti APM',
        CreditsLoading: 'Caricamento crediti'
    },
    panel: {},
    entry: {
        Client: 'Cliente',
        OrderDate: `Data dell'ordine`,
        DeliverDate: 'Data di consegna',
        Description: 'Descrizione',
        Total: 'Totale'
    },
    board: {
        Order: 'ORDINE',
        Date: 'DATA',
        Total: 'TOTALE'
    },
    order: {
        OrderID: 'ID ordine',
        PurchasePlace: 'Luogo',
        PurchaseDate: `Data dell'ordine`,
        TotalPrice: 'Prezzo totale',
    },
    product: {
        Name: 'Nome',
        SKU: 'SKU',
        Size: 'Dimensione',
        Quantity: 'Quantità',
        Price: 'Prezzo',
        WarrantyUntil: 'Garantito fino a',
    }
}


// WEBPACK FOOTER //
// ./src/locales/it/index.js